import { createStore, applyMiddleware, compose } from "redux";

import thunk from "redux-thunk";
import { isLogEnabled, REACT_APP_ENV } from "../../index";

import rootReducer from "./rootReducer";

const composeEnhancers = compose;

const middlewares = [];

if (REACT_APP_ENV !== "prod" && isLogEnabled) {
  const { logger } = require(`redux-logger`);

  middlewares.push(logger);
}
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares, thunk))
);

export { store };
